// @flow
import ApiError from 'PMT/entities/ApiError';
import ApiRestaurantsGroup from 'PMT/api/ApiRestaurantsGroup';
import AppDispatcher from 'PMT/flux/AppDispatcher';

import ActionTypes from '../constants/ActionTypes';

export default class RestaurantsGroupAction {
  static loadApiConsumers(restaurantsGroupId, options = {}) {
    AppDispatcher.handleServerAction({
      type: ActionTypes.GET_API_CONSUMERS,
    });

    ApiRestaurantsGroup.getApiConsumers(
      restaurantsGroupId,
      options,
      RestaurantsGroupAction.receiveApiConsumers,
      RestaurantsGroupAction.receiveApiConsumersError
    );
  }

  static receiveApiConsumers(data) {
    AppDispatcher.handleServerAction({
      type: ActionTypes.GET_API_CONSUMERS_SUCCESS,
      data,
    });
  }

  static receiveApiConsumersError(apiError: ApiError) {
    AppDispatcher.handleServerAction({
      type: ActionTypes.GET_API_CONSUMERS_FAILURE,
      apiError,
    });
  }

  static loadOrderStatistics(
    restaurantsGroupId,
    timelapse,
    modes,
    sourcesList,
    paymentMethods,
    restaurantsIds
  ) {
    AppDispatcher.handleServerAction({
      type: ActionTypes.GET_ORDER_STATISTICS,
    });

    ApiRestaurantsGroup.getOrderStatistics(
      restaurantsGroupId,
      timelapse.getFromTimeAsMilliseconds(),
      timelapse.getToTimeAsMilliseconds(),
      modes,
      sourcesList,
      paymentMethods,
      restaurantsIds,
      RestaurantsGroupAction.receiveOrderStatistics,
      RestaurantsGroupAction.receiveOrderStatisticsError
    );
  }

  static receiveOrderStatistics(data) {
    AppDispatcher.handleServerAction({
      type: ActionTypes.GET_ORDER_STATISTICS_SUCCESS,
      data,
    });
  }

  static receiveOrderStatisticsError(apiError: ApiError) {
    AppDispatcher.handleServerAction({
      type: ActionTypes.GET_ORDER_STATISTICS_FAILURE,
      apiError,
    });
  }
}
